module.exports = __webpack_public_path__ + "static/media/13-deodato-ramalho.759e2846.webp";